"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfStylesImporter = void 0;
var tslib_1 = require("tslib");
var list_1 = require("@devexpress/utils/lib/utils/list");
var number_1 = require("@devexpress/utils/lib/utils/map/number");
var importer_base_1 = require("./importer-base");
var character_style_importer_1 = require("./styles/character-style-importer");
var paragraph_style_importer_1 = require("./styles/paragraph-style-importer");
var table_style_importer_1 = require("./styles/table-style-importer");
var RtfStylesImporter = (function (_super) {
    tslib_1.__extends(RtfStylesImporter, _super);
    function RtfStylesImporter(data) {
        var _this = _super.call(this, data) || this;
        _this.linkParagraphStyleIndexToCharacterStyleIndex = {};
        _this.nextParagraphStyleIndexTable = {};
        _this.paragraph = new paragraph_style_importer_1.RtfParagraphStyleImporter(data);
        _this.paragraph.mapRtfIndexToModelIndex[0] = 0;
        _this.character = new character_style_importer_1.RtfCharacterStyleImporter(data);
        _this.table = new table_style_importer_1.RtfTableStyleImporter(data);
        _this.importers = [
            _this.paragraph,
            _this.character,
            _this.table,
        ];
        return _this;
    }
    RtfStylesImporter.prototype.applyStyleLinks = function () {
        var _this = this;
        number_1.NumberMapUtils.forEach(this.linkParagraphStyleIndexToCharacterStyleIndex, function (rtfCharStyleInd, rtfParStyleInd) {
            if (_this.paragraph.mapRtfIndexToModelIndex[rtfParStyleInd] !== undefined &&
                _this.character.mapRtfIndexToModelIndex[rtfCharStyleInd] !== undefined) {
                var parStyle = _this.paragraph.getModelIndex(rtfParStyleInd);
                var charStyle = _this.character.getModelIndex(rtfCharStyleInd);
                _this.documentModel.stylesManager.registerLink(_this.documentModel.characterStyles[charStyle], _this.documentModel.paragraphStyles[parStyle]);
            }
        });
        number_1.NumberMapUtils.forEach(this.nextParagraphStyleIndexTable, function (rtfNextStyleIndex, rtfParStyleInd) {
            if (_this.paragraph.mapRtfIndexToModelIndex[rtfParStyleInd] !== undefined &&
                _this.paragraph.mapRtfIndexToModelIndex[rtfNextStyleIndex] !== undefined) {
                var parStyle = _this.paragraph.getModelIndex(rtfParStyleInd);
                var nextParStyle = _this.paragraph.getModelIndex(rtfNextStyleIndex);
                _this.documentModel.paragraphStyles[parStyle].nextParagraphStyle = _this.documentModel.paragraphStyles[nextParStyle];
            }
        });
    };
    RtfStylesImporter.prototype.pushState = function () {
        for (var _i = 0, _a = this.importers; _i < _a.length; _i++) {
            var imp = _a[_i];
            imp.pushState();
        }
    };
    RtfStylesImporter.prototype.popState = function () {
        list_1.ListUtils.reverseForEach(this.importers, function (imp) { return imp.popState(); });
    };
    RtfStylesImporter.prototype.startImportSubDocument = function () {
        for (var _i = 0, _a = this.importers; _i < _a.length; _i++) {
            var imp = _a[_i];
            imp.startImportSubDocument();
        }
    };
    RtfStylesImporter.prototype.finalizeSubDocument = function () {
    };
    return RtfStylesImporter;
}(importer_base_1.RtfBaseImporter));
exports.RtfStylesImporter = RtfStylesImporter;
